import { Block, FurnitureListing } from '@shared/models';

export const listingMeublesImageNomMock = (productType: string): Block<FurnitureListing> => ({
  type: 'listing-meubles-image-nom',
  data: {
    productType,
    infoText: 'Toutes nos niches et étagères sont disponibles en plusieurs largeurs.',
    iconText: {
      icon: {
        svg: '/assets/tmp/store.svg',
      },
      text: 'Tous nos meubles et mécanismes sont garantis 10 ans',
    },
  },
});
